"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lucide_vue_next_1 = require("lucide-vue-next");
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SummaryTable_vue_1 = __importDefault(require("../components/SummaryTable.vue"));
const FieldsSetupFlowController_1 = __importDefault(require("../modules/controllers/FieldsSetupFlowController"));
const StepHeader_vue_1 = __importDefault(require("../components/StepHeader.vue"));
const StepFooter_vue_1 = __importDefault(require("../components/StepFooter.vue"));
let SummaryStep = class SummaryStep extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.MAIN_CONTROLLER = FieldsSetupFlowController_1.default.getInstance();
        this.STEP_CONTROLLER = this.MAIN_CONTROLLER.fieldsSummaryStep;
        this.NEXT_STEP_CONTROLLER = this.MAIN_CONTROLLER;
        this.BEFORE_STEP = this.MAIN_CONTROLLER.fieldsPreviewTableStep;
        this.loadingNextView = false;
        this.displayModal = false;
        this.modalContent = {
            type: '',
            response: '',
            warnings: []
        };
        this.extensionLimits = {
            field: {
                min_ha: '0.0001 ha',
                min_ac: '0.00025 ac',
                max_ha: '500 ha',
                max_ac: '1235.53 ac'
            },
            farm: {
                max_ha: '3500 ha',
                max_ac: '8648.69 ac'
            }
        };
        this.numFarmsCreated = 0;
    }
    get isAddingFields() {
        return this.MAIN_CONTROLLER.isAddingFields;
    }
    beforeStep() {
        this.STEP_CONTROLLER.resetStep();
        this.MAIN_CONTROLLER.setCurrentStep(this.BEFORE_STEP);
        this.BEFORE_STEP.resetSelectedFields();
    }
    async nextStep() {
        this.loadingNextView = true;
        const response = await this.STEP_CONTROLLER.sendFields();
        this.processResponse(response);
        this.displayModal = true;
        /*  this.NEXT_STEP_CONTROLLER.addFields(economicFields);
             const economicFields = this.STEP_CONTROLLER.data.fields.map(field => this.STEP_CONTROLLER.createEconomicField(field));
             this.MAIN_CONTROLLER.setCurrentStep(this.NEXT_STEP_CONTROLLER);
         */
    }
    processResponse(response) {
        this.modalContent.warnings = [];
        let eventObj = {
            name: 'Farm Upload',
            props: {}
        };
        if (response.status === 200) {
            this.modalContent.type = 'ok';
            this.modalContent.response = response.messages;
            this.modalContent.warnings = this.getWarningValues(response.ignored);
            this.numFarmsCreated = !isNaN(response.created) ? parseInt(response.created) : 0;
            eventObj.status = 'ok';
            eventObj.props.numberOfFarms = this.numFarmsCreated;
        }
        else {
            this.modalContent.type = 'error';
            if (response.type === 'error' && response.messages !== undefined) {
                this.modalContent.response = response.messages;
            }
            else {
                this.modalContent.response = this.$trans('setup_activation.responses.error.unexpected_error_has_occurred');
            }
            eventObj.status = 'error';
        }
        eventObj.props.extension = this.STEP_CONTROLLER.data.fields.reduce((sum, item) => sum + item.size, 0);
        eventObj.props.extensionUnit = this.STEP_CONTROLLER.data.fields[0].sizeUnit;
        eventObj.props.crops = this.STEP_CONTROLLER.data.fields.map((f) => f.crop).filter((crop, index, self) => index === self.findIndex(c => c.id === crop.id));
        let mode = (this.MAIN_CONTROLLER.isAddingFields) ? 'Edition' : 'Setup';
        this.MAIN_CONTROLLER.logActivity({
            'name': `Farm ${mode} Step 4 Completed`,
        });
        if (!this.MAIN_CONTROLLER.isAddingFields) {
            this.$emit('logActivity', eventObj);
        }
    }
    getWarningValues(obj, values = []) {
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                this.getWarningValues(obj[key], values);
            }
            else if (typeof obj[key] === 'string') {
                values.push(obj[key]);
            }
        }
        return values;
    }
    goToFarmsList() {
        if (this.MAIN_CONTROLLER.isAddingFields) {
            window.location.href = `/farm/${this.MAIN_CONTROLLER.farmIdToAddFieldsTo}/edit`;
        }
        else {
            window.location.href = `/farm/list?just_created=true&new_farms=${this.numFarmsCreated}`;
        }
    }
};
SummaryStep = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { AlertTriangle: lucide_vue_next_1.AlertTriangle, Button: bmk_ui_framework_1.Button, Modal: bmk_ui_framework_1.Modal, SummaryTable: SummaryTable_vue_1.default, StepFooter: StepFooter_vue_1.default, StepHeader: StepHeader_vue_1.default, CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon, WarningTriangledIcon: bmk_ui_framework_1.WarningTriangledIcon, XAloneIcon: bmk_ui_framework_1.XAloneIcon }
    })
], SummaryStep);
exports.default = SummaryStep;
